<div class="tw-fixed tw-top-4 tw-inset-x-4 tw-z-50 tw-flex tw-justify-center tw-pointer-events-none">
  <div class="tw-pointer-events-auto tw-flex tw-items-center tw-gap-3 tw-bg-neutral-0 tw-border tw-border-solid tw-border-neutral-100 tw-shadow-input tw-rounded-2xl md:tw-rounded-full tw-py-2 tw-pl-4 tw-pr-2"
       role="status"
       aria-live="polite">
    <mat-icon svgIcon="magic" class="icon-size-20 tw-flex-shrink-0 tw-text-main-primary"></mat-icon>
    <span class="tw-typography-body tw-text-neutral-700" i18n="@@core.update.notice.message">A new version of Letly is available</span>
    <letly-button class="tw-flex-shrink-0" variant="primary" size="small" [label]="refreshLabel" (click)="refresh()"></letly-button>
    <button
      type="button"
      class="tw-flex-shrink-0 tw-w-8 tw-h-8 tw-inline-flex tw-items-center tw-justify-center tw-rounded-control tw-border-0 tw-bg-transparent tw-text-neutral-400 hover:tw-bg-neutral-50 hover:tw-text-main-primaryText tw-cursor-pointer"
      aria-label="Dismiss"
      i18n-aria-label="@@core.update.notice.dismiss.aria"
      (click)="dismiss()">
      <mat-icon svgIcon="close" class="icon-size-20"></mat-icon>
    </button>
  </div>
</div>
